import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

/**
 * "Panel · Version history (HP)" (Figma 3141:9996) — LIVE: rows come from
 * /v4/hp/list + the latest plan (toVersionRows). Opens from the sidebar's
 * VERSIONS toggle or the "Version N" title. PORTALLED to <body> with a dim
 * backdrop — anchoring it inside the 250px sidebar clipped it at the sidebar's
 * edge. "Open" loads that version (read-only unless it's the latest draft).
 */
const VersionHistoryPanel = ({ rows, latestId, viewingId, onOpen, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      className="hp-voverlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="hp-vpanel" role="dialog" aria-label="Version history">
        <div className="hp-vpanel-head">
          <div className="hp-vpanel-title-row">
            <h3>Version history</h3>
            <span className="hp-badge">AUTO-VERSIONED</span>
          </div>
          <p>
            A new version is created automatically whenever the health plan or
            the detailed assessment is updated.
          </p>
        </div>

        {rows.length === 0 && (
          <div className="hp-vrow">
            <div className="hp-vmeta">No saved versions yet.</div>
          </div>
        )}

        {rows.map((r) => {
          const isViewing = r.id === viewingId;
          return (
            <div className={`hp-vrow${r.id === latestId ? " is-current" : ""}`} key={r.id}>
              <div className="hp-vrow-top">
                <span className="hp-vname">Version {r.version}</span>
                {r.id === latestId && <span className="hp-vbadge">CURRENT</span>}
                {r.published && r.id !== latestId && (
                  <span className="hp-vbadge is-published">PUBLISHED</span>
                )}
                <button
                  type="button"
                  className={`hp-vaction${isViewing ? " is-viewing" : ""}`}
                  disabled={isViewing}
                  onClick={() => onOpen(r.id)}
                >
                  {isViewing ? "Viewing" : "Open"}
                </button>
              </div>
              <div className="hp-vmeta">{r.meta}</div>
            </div>
          );
        })}
      </div>
    </div>,
    document.body
  );
};

VersionHistoryPanel.propTypes = {
  /** [{ id, version, published, meta }] newest-first. */
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  latestId: PropTypes.any,
  viewingId: PropTypes.any,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default VersionHistoryPanel;
